<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    rules: { type: String, default: '' },
    label: { type: String, default: null },
  },
}
</script>

<template>
  <BaseValidationProvider
    v-slot="{ errors }"
    :rules="rules"
    :label="label"
    :label-for="$attrs.id"
  >
    <BaseDatepicker
      :value="$attrs.value"
      :class="['input', errors.length ? 'input-error' : '']"
      @input="$emit('update', $event.target.value)"
    />
  </BaseValidationProvider>
</template>
